import { useContext } from 'react';
import { CtiStoreContext } from '../hoc/withCtiStore';

export default function useCtiStore() {
  const ctiStore = useContext(CtiStoreContext);

  return ctiStore;
}
